module.exports = __webpack_public_path__ + "img/pos.e0ab3a77.png";